export default __webpack_public_path__ + "static/Mia-c464a8b369f751fb37a0f8610329ea0b.jpg";